import React from "react";
import Pharmacys from "../components/Pharmacys/";
const Farmacy = () => {
  return <Pharmacys />;
};

export default Farmacy;
